export const SELECT_PROCESS = "SELECT_PROCESS";
